import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import {
  deleteImages,
  selectSelectedImages,
  selectLoading,
} from "../../../Store/Gmb/gmbImageSlice";

const DeleteModal = ({
  accountId,
  locationId,
  onImageUpdate,
  onDeleteComplete,
}) => {
  const dispatch = useDispatch();
  const selectedImages = useSelector(selectSelectedImages);
  const { delete: isLoading } = useSelector(selectLoading);
  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = async () => {
    await dispatch(
      deleteImages({
        account_id: accountId,
        location_id: locationId,
        selectedImages,
      }),
    ).unwrap();

    onImageUpdate();
    onDeleteComplete();
    setIsOpen(false);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  if (selectedImages.length === 0) return null;

  return (
    <>
      <button
        onClick={toggleModal}
        className="bg-red-500 text-white px-4 py-2 rounded-2xl flex flex-row justify-between capitalize shadow-[0_4px_8px_3px_rgba(0,0,0,0.15)]"
        type="button"
      >
        Delete {selectedImages.length} Selected
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center z-[999999] bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm"
          onClick={toggleModal}
        >
          <div
            className="relative p-6 w-full max-w-md bg-white rounded-lg shadow"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5"
              onClick={toggleModal}
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>

            <div className="flex flex-col items-center">
              <svg
                className="text-gray-600 w-11 h-11 mb-3.5"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              <p className="mb-4 text-black">
                Are you sure you want to delete selected images?
              </p>
              <div className="flex justify-center items-center space-x-4">
                <button
                  onClick={toggleModal}
                  type="button"
                  className="py-2 px-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 hover:text-gray-900"
                >
                  No, cancel
                </button>
                <button
                  onClick={handleDelete}
                  className="py-2 px-3 text-sm font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 flex justify-center items-center"
                >
                  {isLoading ? (
                    <CircularProgress size="16px" color="inherit" />
                  ) : (
                    "Yes, I'm sure"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteModal;
